import { List, Map } from "immutable";

export default {
  vesselMovements: Map(),
  vesselPositions: Map(),
  vesselInfos: Map(),
  currentTime: null,
  featuresForPoint: List(),
  featuresForVector: List(),
  featuresForPolygon: List(),
  featuresForWake: List(),
  selectedVesselIds: List(),
  selectedVesselMap: Map(),  // 選択中の船舶ID
  enterpriseVesselMap: Map(), // 自社船管理
}
